import React, { useEffect } from 'react'
import { connect } from 'react-redux'
import { Breadcrumb, Button } from 'semantic-ui-react'
import { rootPath, adminPath, prMappingDataPath } from 'routes'
import { PRManagementContainer } from './styled'
import { AdminContainer } from '../styled'
import { collapseSideMenu as toggleSideMenu } from 'ducks/app'

const PRManagement = (props) => {
  const { user, history } = props

  React.useEffect(() => {
    if (!props.collapseMenu) {
      props.toggleSideMenu()
    }

    return () => {
      if (props.collapseMenu && !history.location.pathname.includes('admin')) {
        props.toggleSideMenu()
      }
    }
  })

  useEffect(() => {
    if (user) {
      if (user.isAdmin === false) {
        history.replace(rootPath)
      }
    }
  }, [user])

  const sections = [
    { key: 'Admin', content: 'Admin', link: true, onClick: () => history.push(adminPath) },
    { key: 'PRManagement', content: 'Purchase Requisition Managements', active: true },
  ]
  
  return (
    <AdminContainer>
      <div className='adminHeader'>
        <div className='headerTitle'>Purchase Requisition Managements</div>
        <Breadcrumb icon='right angle' sections={sections} />
      </div>
      <PRManagementContainer>
        <Button onClick={() => props.history.push(prMappingDataPath)} content='Mappings' />
        <Button onClick={() => alert('Coming soon.')} content='Categories' />
      </PRManagementContainer>
    </AdminContainer>
  )
}

const mapStateToProps = (state) => {
  return ({
    user: state.authen.user,
    collapseMenu: state.app.collapseSideMenu,
  })
}

const mapDispatchToProps = {
  toggleSideMenu
}

export default connect(mapStateToProps, mapDispatchToProps)(PRManagement)